import { forwardRef } from 'react'
import './controls.css'
export default forwardRef(function FilterChip({ active = false, className = '', ...props }, ref) {
    return <button aria-pressed={active} {...props} ref={ref} data-active={active} className={'uiFilterChip ' + className} />
})
